import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'

import { unfollow, getUsersByIds } from 'client/bookmate/reducers/users-reducer'

import { UserInfo } from 'client/bookmate/blocks/user-info'
import { Dispatch, State } from 'shared/types/redux'
import { UserCombined, UserShort } from 'client/shared/types/user'
import { QueryParams } from 'shared/tools/url-helper'

type Props = {
  user: UserCombined
  followers: UserShort[]
  dispatch: Dispatch
  query?: QueryParams
}

class UserInfoBox extends Component<Props> {
  unfollowUser = () => {
    const { dispatch, user } = this.props

    return dispatch(unfollow(user))
  }

  render(): JSX.Element {
    const { user, followers, query } = this.props

    return (
      <UserInfo
        query={query}
        user={user}
        followers={followers}
        unfollowUser={this.unfollowUser}
      />
    )
  }
}

const connectWrapper = connect((state: State) => ({
  followers: getUsersByIds(state, state.user.followersUsers),
  query: state.app.storedQuery,
}))

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(UserInfoBox)
